// Formatação comum dos painéis — números e datas sempre em pt-BR.
export const formataNumero = (n) => Number(n || 0).toLocaleString('pt-BR');

export const formataPct = (parte, total) => {
  if (!total) return '—';
  return `${((100 * parte) / total).toLocaleString('pt-BR', {
    minimumFractionDigits: 1,
    maximumFractionDigits: 1,
  })}%`;
};

export const formataDataHora = (iso) => {
  if (!iso) return '—';
  const d = new Date(iso);
  if (Number.isNaN(d.getTime())) return '—';
  const p = (x) => String(x).padStart(2, '0');
  return `${p(d.getDate())}/${p(d.getMonth() + 1)}/${d.getFullYear()} ${p(d.getHours())}:${p(d.getMinutes())}`;
};

const casas = (x, d) => x.toLocaleString('pt-BR', { minimumFractionDigits: d, maximumFractionDigits: d });

// Reais compactos para cards e rótulos ("R$ 412,3 mi"); o valor cheio vai no
// tooltip com formataReaisCheio.
export const formataReais = (v) => {
  if (v === null || v === undefined) return '—';
  const n = Number(v);
  if (!Number.isFinite(n)) return '—';
  const abs = Math.abs(n);
  // A unidade sai do valor JÁ arredondado na unidade de baixo: 999.950 virava
  // "R$ 1.000,0 mil" em vez de "R$ 1,0 mi".
  if (abs >= 1e9 - 5e4) return `R$ ${casas(n / 1e9, 2)} bi`;
  if (abs >= 1e6 - 50) return `R$ ${casas(n / 1e6, 1)} mi`;
  if (abs >= 1e3 - 0.5) return `R$ ${casas(n / 1e3, 1)} mil`;
  return `R$ ${casas(n, 0)}`;
};

// Rótulo de coluna: o "R$" vai uma vez na legenda, não em cada uma das 12–15
// colunas (com ele o valor não cabe na largura da coluna).
export const formataReaisCurto = (v) => formataReais(v).replace(/^R\$\s/, '');

export const formataReaisCheio = (v) =>
  Number(v || 0).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' });

const seta = (v) => (v >= 0 ? '▲' : '▼');

export const formataVariacao = (v) =>
  (v === null || v === undefined ? '—' : `${seta(v)} ${casas(Math.abs(v) * 100, 1)}%`);

export const formataPontos = (v) =>
  (v === null || v === undefined ? '—' : `${seta(v)} ${casas(Math.abs(v) * 100, 1)} p.p.`);

// Fração (0,233) como porcentagem ("23,3%"); nulo vira "—".
export const formataFracao = (v) =>
  (v === null || v === undefined ? '—' : `${casas(v * 100, 1)}%`);
